// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type QuestionMarkCircle40Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const QuestionMarkCircle40: FC<QuestionMarkCircle40Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M19.75 29.472c.49 0 .905-.169 1.243-.507a1.69 1.69 0 0 0 .507-1.243c0-.49-.169-.905-.507-1.243a1.69 1.69 0 0 0-1.243-.507c-.49 0-.905.17-1.243.507A1.69 1.69 0 0 0 18 27.722c0 .49.169.905.507 1.243a1.69 1.69 0 0 0 1.243.507Zm-1.472-6.194h2.667c0-.787.094-1.468.284-2.042.19-.574.762-1.273 1.716-2.097.814-.723 1.412-1.424 1.791-2.104.38-.681.57-1.452.57-2.313 0-1.5-.51-2.685-1.528-3.555-1.019-.87-2.315-1.306-3.89-1.306-1.434 0-2.663.366-3.687 1.097A6.081 6.081 0 0 0 14 13.833l2.389.917c.25-.685.66-1.269 1.229-1.75.57-.481 1.299-.722 2.187-.722.927 0 1.658.252 2.195.757.537.504.805 1.122.805 1.854 0 .593-.175 1.15-.527 1.674-.352.523-.843 1.048-1.473 1.576-.962.843-1.624 1.593-1.985 2.25s-.542 1.62-.542 2.889Zm1.389 13.055c-2.287 0-4.445-.437-6.472-1.312-2.028-.875-3.797-2.067-5.306-3.576-1.51-1.51-2.702-3.279-3.577-5.306C3.438 24.11 3 21.954 3 19.667c0-2.306.438-4.473 1.313-6.5.875-2.028 2.067-3.792 3.576-5.292 1.51-1.5 3.278-2.688 5.306-3.563C15.222 3.438 17.38 3 19.667 3c2.305 0 4.472.438 6.5 1.313 2.027.875 3.791 2.062 5.291 3.562 1.5 1.5 2.688 3.264 3.563 5.292.875 2.027 1.312 4.194 1.312 6.5 0 2.287-.437 4.444-1.312 6.472-.875 2.027-2.063 3.796-3.563 5.306-1.5 1.509-3.264 2.7-5.291 3.576-2.028.875-4.195 1.312-6.5 1.312Zm0-2.778c3.87 0 7.152-1.351 9.847-4.055 2.694-2.704 4.041-5.981 4.041-9.833 0-3.87-1.347-7.153-4.041-9.847-2.695-2.695-5.977-4.042-9.847-4.042-3.852 0-7.13 1.347-9.834 4.042-2.703 2.694-4.055 5.976-4.055 9.847 0 3.852 1.352 7.13 4.055 9.833 2.704 2.704 5.982 4.055 9.834 4.055Z" />
        </svg>
    );
};

export default QuestionMarkCircle40;
